<template>
  <div
    id="poster-design"
  >
    <div
      class="mb-4 title text-center"
    >
      <h1>{{ data.name }}</h1>
      <h5>{{ data.code }}</h5>
    </div>
    <div
      class="text-center d-flex justify-content-center"
    >
      <qrcode-vue
        :value="qrData.value"
        :size="qrSize"
        level="H"
      />
    </div>
    <div>
      <!-- eslint-disable-next-line vue/no-v-html -->
      <div v-html="data.description" />
    </div>
  </div>
</template>

<script>
import QrcodeVue from 'qrcode.vue'

export default {
  components: {
    QrcodeVue,
  },
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
    qrData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      qrSize: 150,
    }
  },
}
</script>
